import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }

  textarea {
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 4px;
    color: #dee2e6;
    background: #323a4e;
    padding: 10px 20px;
    height: 200px;
    width: 100%;
    resize: none;
    margin-top: 0.8rem;
  }

  label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
  }
`;

export const Button = styled.button.attrs({
  type: 'submit',
})`
  background: #626ed4;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 10px;
  margin-top: 20px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }
`;
